import { render, staticRenderFns } from "./TranslationEntry.vue?vue&type=template&id=9220d00a&scoped=true&"
import script from "./TranslationEntry.vue?vue&type=script&lang=js&"
export * from "./TranslationEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9220d00a",
  null
  
)

export default component.exports